import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Header from './components/Header';
import Home from './Home';
import LeaguesPage from './components/LeaguesPage';
import OnboardingPage from './components/OnboardingPage';
import Settings from './components/Settings';
import League from './components/League';
import Team from './components/Team';
import Matchup from './components/Matchup';
import TradeAnalyzer from './components/TradeAnalyzer';
import PlayerComparison from './components/PlayerComparison';
import PlayerDetail from './components/PlayerDetail';

const AppContent: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg-primary">
      <Header />
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Home />} />
        
        {/* Protected routes */}
        <Route path="/leagues" element={
          <ProtectedRoute>
            <LeaguesPage />
          </ProtectedRoute>
        } />
        <Route path="/onboarding" element={
          <ProtectedRoute>
            <OnboardingPage />
          </ProtectedRoute>
        } />
        <Route path="/settings" element={
          <ProtectedRoute>
            <Settings />
          </ProtectedRoute>
        } />
        <Route path="/league/:leagueId" element={
          <ProtectedRoute>
            <League />
          </ProtectedRoute>
        } />
        <Route path="/league/:leagueId/team/:teamId" element={
          <ProtectedRoute>
            <Team />
          </ProtectedRoute>
        } />
        <Route path="/league/:leagueId/matchup/:matchupId" element={
          <ProtectedRoute>
            <Matchup />
          </ProtectedRoute>
        } />
        <Route path="/trade-analyzer" element={
          <ProtectedRoute>
            <TradeAnalyzer />
          </ProtectedRoute>
        } />
        <Route path="/player-comparison" element={
          <ProtectedRoute>
            <PlayerComparison />
          </ProtectedRoute>
        } />
        <Route path="/player/:playerName" element={
          <ProtectedRoute>
            <PlayerDetail />
          </ProtectedRoute>
        } />
        
        {/* Catch all route - redirect to home */}
        <Route path="*" element={<Home />} />
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;